export const getDateFormat = () => {
    const server = process.env.REACT_APP_SECURAZE_SERVER;
    if (server?.includes("US")) {
        return 'MM/DD/YYYY';
    }
    return 'DD.MM.YYYY';
}
